// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/users.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/collapse.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/expand.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/add.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../assets/edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../assets/notesEditor/trash.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meetingPageNotes {
    background: #FFFFFF;
    border-radius: 8px;
    border: 0.5px solid rgba(0, 0, 0, 0.08);
    overflow: hidden;
    margin-bottom: 12px;
}

.meetingPageNotes_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s ease;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);
}

.meetingPageNotes_header:hover {
    background-color: rgba(0, 0, 0, 0.02);
}

.meetingPageNotes_title_wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.meetingPageNotes_title {
    font-size: calc(15px * var(--fontScaler));
    font-weight: 500;
    color: #1D1D1F;
}

.meetingPageNotes_filter_icon {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 16px;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.2s ease;
}

.meetingPageNotes_filter_icon:hover {
    opacity: 1;
}

.meetingPageNotes_filter_icon--active {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    opacity: 0.7;
}

.meetingPageNotes_filter_icon--active:hover {
    opacity: 1;
}

.meetingPageNotes_toggle {
    display: flex;
    align-items: center;
    justify-content: center;
}

.meetingPageNotes_toggle_icon {
    width: 16px;
    height: 16px;
    position: relative;
}

.meetingPageNotes_toggle_icon::before,
.meetingPageNotes_toggle_icon::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    transition: opacity 0.2s ease;
    opacity: 0.6;
}

.meetingPageNotes_toggle_icon::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.meetingPageNotes_toggle_icon::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    opacity: 0;
}

.meetingPageNotes--collapsed .meetingPageNotes_toggle_icon::before {
    opacity: 0;
}

.meetingPageNotes--collapsed .meetingPageNotes_toggle_icon::after {
    opacity: 0.6;
}

.meetingPageNotes_drop {
    display: grid;
    grid-template-rows: 1fr;
    transition: grid-template-rows 200ms cubic-bezier(0.075, 0.82, 0.165, 1);
    overflow: hidden;
}

.meetingPageNotes--collapsed .meetingPageNotes_drop {
    grid-template-rows: 0fr;
}

.meetingPageNotes_drop_content {
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
}

.meetingPageNotes_actions {
    padding: 12px 0;
    border-top: 0.5px solid rgba(0, 0, 0, 0.06);
}

.meetingPageNotes_add_wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: opacity 0.2s ease;
    opacity: 0.7;
}

.meetingPageNotes_add_wrapper:hover {
    opacity: 1;
}

.meetingPageNotes_add_icon {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: 11px;
    background-position: center;
    background-repeat: no-repeat;
}

.meetingPageNotes_add_text {
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    color: #1D1D1F;
}

.meetingPageNotes_loading {
    text-align: center;
    color: #86868B;
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    padding: 20px 16px;
}

.meetingPageNotes_content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    max-height: 350px;
    padding: 8px 16px;
}

.meetingPageNotes_list {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.meetingPageNotes_item {
    background: #FFFFFF;
    border-bottom: 0.5px solid #E5E5EA;
    overflow: hidden;
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.meetingPageNotes_item:last-child {
    border-bottom: none;
}

.meetingPageNotes_item:hover:not(.meetingPageNotes_item--expanded) {
    background: #FAFAFA;
}

.meetingPageNotes_item--expanded {
    background: #F9F9FB;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.04);
    border-bottom: 0.5px solid #E5E5EA;
}

.meetingPageNotes_item_head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    cursor: pointer;
    transition: background 0.2s ease;
}

.meetingPageNotes_item_left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
}

.meetingPageNotes_item_title {
    font-weight: 500;
    font-size: calc(13px * var(--fontScaler));
    line-height: 20px;
    color: #1D1D1F;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
}

.meetingPageNotes_item_date {
    font-weight: 400;
    font-size: calc(11px * var(--fontScaler));
    line-height: 16px;
    color: #86868B;
    white-space: nowrap;
    flex-shrink: 0;
}

.meetingPageNotes_item_actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.meetingPageNotes_edit_button {
    width: 20px;
    height: 20px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 14px;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.6;
    cursor: pointer;
    transition: opacity 0.2s ease;
}

.meetingPageNotes_edit_button:hover {
    opacity: 1;
}

.meetingPageNotes_open_button {
    width: 20px;
    height: 20px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 14px;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.6;
    cursor: pointer;
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.meetingPageNotes_open_button:hover {
    opacity: 1;
}

.meetingPageNotes_item--expanded .meetingPageNotes_open_button {
    transform: rotate(180deg);
}

.meetingPageNotes_item_preview {
    padding: 8px 0;
    border-top: 0.5px solid #F5F5F7;
    max-height: 100px;
    overflow-y: auto;
}

.meetingPageNotes_preview_text {
    font-size: calc(12px * var(--fontScaler));
    line-height: 1.5;
    color: #3C3C43;
}

.meetingPageNotes_item_content {
    padding: 0 0 12px 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-top: 0.5px solid #F5F5F7;
    margin-top: 6px;
    padding-top: 10px;
}

.meetingPageNotes_edit_section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.meetingPageNotes_title_input {
    width: 100%;
    padding: 8px 10px;
    font-size: calc(13px * var(--fontScaler));
    font-weight: 500;
    color: #1D1D1F;
    background: #F9F9FB;
    border: 0.5px solid #D1D1D6;
    border-radius: 6px;
    outline: none;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.meetingPageNotes_title_input:focus {
    border-color: #007AFF;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
}

.meetingPageNotes_bound_toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: calc(12px * var(--fontScaler));
    color: #86868B;
    transition: color 0.2s;
    user-select: none;
}

.meetingPageNotes_bound_toggle:hover {
    color: #1D1D1F;
}

.meetingPageNotes_bound_toggle input[type="checkbox"] {
    width: 14px;
    height: 14px;
    cursor: pointer;
    accent-color: #007AFF;
}

.meetingPageNotes_toolbar {
    display: flex;
    gap: 4px;
    padding: 4px;
    background: #FAFAFA;
    border: 0.5px solid #E5E5EA;
    border-radius: 6px;
}

.meetingPageNotes_toolbar_btn {
    padding: 4px 8px;
    background: #FFFFFF;
    border: 0.5px solid #D1D1D6;
    border-radius: 4px;
    cursor: pointer;
    font-size: calc(11px * var(--fontScaler));
    transition: all 0.2s ease;
    color: #1D1D1F;
}

.meetingPageNotes_toolbar_btn:hover {
    background: #F5F5F7;
    border-color: #007AFF;
}

.meetingPageNotes_text_editor {
    width: 100%;
    height: 80px;
    padding: 10px;
    font-size: calc(12px * var(--fontScaler));
    line-height: 1.5;
    color: #1D1D1F;
    background: #F9F9FB;
    border: 0.5px solid #D1D1D6;
    border-radius: 6px;
    outline: none;
    overflow-y: auto;
    font-family: inherit;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.meetingPageNotes_text_editor:focus {
    border-color: #007AFF;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
}

.meetingPageNotes_saving_indicator {
    font-size: calc(10px * var(--fontScaler));
    color: #86868B;
    font-style: italic;
}

.meetingPageNotes_footer {
    display: flex;
    justify-content: flex-end;
}

.meetingPageNotes_delete_icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    cursor: pointer;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-size: 14px;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.7;
    transition: opacity 0.2s ease;
}

.meetingPageNotes_delete_icon:hover {
    opacity: 1;
}

/* Scrollbar - macOS style */
.meetingPageNotes_content::-webkit-scrollbar {
    width: 6px;
}

.meetingPageNotes_content::-webkit-scrollbar-track {
    background: transparent;
}

.meetingPageNotes_content::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 4px;
}

.meetingPageNotes_content::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.25);
}
`, "",{"version":3,"sources":["webpack://./src/pages/meetingPage/components/meetingPageNotesWidget/MeetingPageNotesWidget.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,uCAAuC;IACvC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,8CAA8C;AAClD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAoD;IACpD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,yDAAwD;AAC5D;;AAEA;IACI,yDAAsD;IACtD,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,wEAAwE;IACxE,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAmD;IACnD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA;IACI,mBAAmB;IACnB,kCAAkC;IAClC,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAAoD;IACpD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY;IACZ,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAAwD;IACxD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY;IACZ,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,yCAAyC;IACzC,cAAc;IACd,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,yCAAyC;IACzC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,yCAAyC;IACzC,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,yDAAiE;IACjE,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA,4BAA4B;AAC5B;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC","sourcesContent":[".meetingPageNotes {\n    background: #FFFFFF;\n    border-radius: 8px;\n    border: 0.5px solid rgba(0, 0, 0, 0.08);\n    overflow: hidden;\n    margin-bottom: 12px;\n}\n\n.meetingPageNotes_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    cursor: pointer;\n    user-select: none;\n    transition: background-color 0.2s ease;\n    border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);\n}\n\n.meetingPageNotes_header:hover {\n    background-color: rgba(0, 0, 0, 0.02);\n}\n\n.meetingPageNotes_title_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.meetingPageNotes_title {\n    font-size: calc(15px * var(--fontScaler));\n    font-weight: 500;\n    color: #1D1D1F;\n}\n\n.meetingPageNotes_filter_icon {\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/user.svg');\n    background-size: 16px;\n    background-position: center;\n    background-repeat: no-repeat;\n    cursor: pointer;\n    opacity: 0.7;\n    transition: opacity 0.2s ease;\n}\n\n.meetingPageNotes_filter_icon:hover {\n    opacity: 1;\n}\n\n.meetingPageNotes_filter_icon--active {\n    background-image: url('../../../../assets/users.svg');\n    opacity: 0.7;\n}\n\n.meetingPageNotes_filter_icon--active:hover {\n    opacity: 1;\n}\n\n.meetingPageNotes_toggle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.meetingPageNotes_toggle_icon {\n    width: 16px;\n    height: 16px;\n    position: relative;\n}\n\n.meetingPageNotes_toggle_icon::before,\n.meetingPageNotes_toggle_icon::after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n    transition: opacity 0.2s ease;\n    opacity: 0.6;\n}\n\n.meetingPageNotes_toggle_icon::before {\n    background-image: url('../../../../assets/collapse.svg');\n}\n\n.meetingPageNotes_toggle_icon::after {\n    background-image: url('../../../../assets/expand.svg');\n    opacity: 0;\n}\n\n.meetingPageNotes--collapsed .meetingPageNotes_toggle_icon::before {\n    opacity: 0;\n}\n\n.meetingPageNotes--collapsed .meetingPageNotes_toggle_icon::after {\n    opacity: 0.6;\n}\n\n.meetingPageNotes_drop {\n    display: grid;\n    grid-template-rows: 1fr;\n    transition: grid-template-rows 200ms cubic-bezier(0.075, 0.82, 0.165, 1);\n    overflow: hidden;\n}\n\n.meetingPageNotes--collapsed .meetingPageNotes_drop {\n    grid-template-rows: 0fr;\n}\n\n.meetingPageNotes_drop_content {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.meetingPageNotes_actions {\n    padding: 12px 0;\n    border-top: 0.5px solid rgba(0, 0, 0, 0.06);\n}\n\n.meetingPageNotes_add_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n    transition: opacity 0.2s ease;\n    opacity: 0.7;\n}\n\n.meetingPageNotes_add_wrapper:hover {\n    opacity: 1;\n}\n\n.meetingPageNotes_add_icon {\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/add.svg');\n    background-size: 11px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.meetingPageNotes_add_text {\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    color: #1D1D1F;\n}\n\n.meetingPageNotes_loading {\n    text-align: center;\n    color: #86868B;\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    padding: 20px 16px;\n}\n\n.meetingPageNotes_content {\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    max-height: 350px;\n    padding: 8px 16px;\n}\n\n.meetingPageNotes_list {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n.meetingPageNotes_item {\n    background: #FFFFFF;\n    border-bottom: 0.5px solid #E5E5EA;\n    overflow: hidden;\n    transition: all 0.2s ease;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n\n.meetingPageNotes_item:last-child {\n    border-bottom: none;\n}\n\n.meetingPageNotes_item:hover:not(.meetingPageNotes_item--expanded) {\n    background: #FAFAFA;\n}\n\n.meetingPageNotes_item--expanded {\n    background: #F9F9FB;\n    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.04);\n    border-bottom: 0.5px solid #E5E5EA;\n}\n\n.meetingPageNotes_item_head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 0;\n    cursor: pointer;\n    transition: background 0.2s ease;\n}\n\n.meetingPageNotes_item_left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex: 1;\n    min-width: 0;\n}\n\n.meetingPageNotes_item_title {\n    font-weight: 500;\n    font-size: calc(13px * var(--fontScaler));\n    line-height: 20px;\n    color: #1D1D1F;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex: 1;\n    min-width: 0;\n}\n\n.meetingPageNotes_item_date {\n    font-weight: 400;\n    font-size: calc(11px * var(--fontScaler));\n    line-height: 16px;\n    color: #86868B;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.meetingPageNotes_item_actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.meetingPageNotes_edit_button {\n    width: 20px;\n    height: 20px;\n    background-image: url('../../../../assets/edit.svg');\n    background-size: 14px;\n    background-position: center;\n    background-repeat: no-repeat;\n    opacity: 0.6;\n    cursor: pointer;\n    transition: opacity 0.2s ease;\n}\n\n.meetingPageNotes_edit_button:hover {\n    opacity: 1;\n}\n\n.meetingPageNotes_open_button {\n    width: 20px;\n    height: 20px;\n    background-image: url('../../../../assets/collapse.svg');\n    background-size: 14px;\n    background-position: center;\n    background-repeat: no-repeat;\n    opacity: 0.6;\n    cursor: pointer;\n    transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.meetingPageNotes_open_button:hover {\n    opacity: 1;\n}\n\n.meetingPageNotes_item--expanded .meetingPageNotes_open_button {\n    transform: rotate(180deg);\n}\n\n.meetingPageNotes_item_preview {\n    padding: 8px 0;\n    border-top: 0.5px solid #F5F5F7;\n    max-height: 100px;\n    overflow-y: auto;\n}\n\n.meetingPageNotes_preview_text {\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 1.5;\n    color: #3C3C43;\n}\n\n.meetingPageNotes_item_content {\n    padding: 0 0 12px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    border-top: 0.5px solid #F5F5F7;\n    margin-top: 6px;\n    padding-top: 10px;\n}\n\n.meetingPageNotes_edit_section {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.meetingPageNotes_title_input {\n    width: 100%;\n    padding: 8px 10px;\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 500;\n    color: #1D1D1F;\n    background: #F9F9FB;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 6px;\n    outline: none;\n    transition: all 0.2s ease;\n    box-sizing: border-box;\n}\n\n.meetingPageNotes_title_input:focus {\n    border-color: #007AFF;\n    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);\n}\n\n.meetingPageNotes_bound_toggle {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-size: calc(12px * var(--fontScaler));\n    color: #86868B;\n    transition: color 0.2s;\n    user-select: none;\n}\n\n.meetingPageNotes_bound_toggle:hover {\n    color: #1D1D1F;\n}\n\n.meetingPageNotes_bound_toggle input[type=\"checkbox\"] {\n    width: 14px;\n    height: 14px;\n    cursor: pointer;\n    accent-color: #007AFF;\n}\n\n.meetingPageNotes_toolbar {\n    display: flex;\n    gap: 4px;\n    padding: 4px;\n    background: #FAFAFA;\n    border: 0.5px solid #E5E5EA;\n    border-radius: 6px;\n}\n\n.meetingPageNotes_toolbar_btn {\n    padding: 4px 8px;\n    background: #FFFFFF;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: calc(11px * var(--fontScaler));\n    transition: all 0.2s ease;\n    color: #1D1D1F;\n}\n\n.meetingPageNotes_toolbar_btn:hover {\n    background: #F5F5F7;\n    border-color: #007AFF;\n}\n\n.meetingPageNotes_text_editor {\n    width: 100%;\n    height: 80px;\n    padding: 10px;\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 1.5;\n    color: #1D1D1F;\n    background: #F9F9FB;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 6px;\n    outline: none;\n    overflow-y: auto;\n    font-family: inherit;\n    transition: all 0.2s ease;\n    box-sizing: border-box;\n}\n\n.meetingPageNotes_text_editor:focus {\n    border-color: #007AFF;\n    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);\n}\n\n.meetingPageNotes_saving_indicator {\n    font-size: calc(10px * var(--fontScaler));\n    color: #86868B;\n    font-style: italic;\n}\n\n.meetingPageNotes_footer {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.meetingPageNotes_delete_icon {\n    width: 18px;\n    height: 18px;\n    flex-shrink: 0;\n    cursor: pointer;\n    background-image: url('../../../../assets/notesEditor/trash.svg');\n    background-size: 14px;\n    background-position: center;\n    background-repeat: no-repeat;\n    opacity: 0.7;\n    transition: opacity 0.2s ease;\n}\n\n.meetingPageNotes_delete_icon:hover {\n    opacity: 1;\n}\n\n/* Scrollbar - macOS style */\n.meetingPageNotes_content::-webkit-scrollbar {\n    width: 6px;\n}\n\n.meetingPageNotes_content::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.meetingPageNotes_content::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.15);\n    border-radius: 4px;\n}\n\n.meetingPageNotes_content::-webkit-scrollbar-thumb:hover {\n    background: rgba(0, 0, 0, 0.25);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
